import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { tempTagServiceConfigSchema } from '../configurations/TempTagServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderTempTagDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.TEMP_TAG]: tempTagServiceConfigSchema,
    }),
});

export { servicesProviderTempTagDataSchema };
//# sourceMappingURL=ServicesProviderTempTagData.js.map
